module.exports = __webpack_public_path__ + "img/sxsjs7.c298be2d.png";